import React from "react";
import PrivacyPolicy from "../../PicesForPages/CommunicationPolicy.webp";
import FreeConsultation from "../Form/FreeConsultation";

function CommunicationPolicy() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={PrivacyPolicy}
          alt="tlpImage"
          className="background-video PrivacyPolicyImage"
        />
        <div className="purchasetopBox">
          {/* The existing Purchase span */}
          <span>Communication Policy</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftHeader">
              SMS Terms & Conditions
            </span>
            <span className="purchaseBottomLeftContent">
              By opting into SMS communications from{" "}
              <span className="logoBoldColor">The Mortgageist Inc.,</span> you
              agree to the following terms:
            </span>
            <ol className="purchaseBottomLeftBox purchaseBottomLeftBox00">
              <li className="purchaseBottomLeftHeader purchaseBottomLeftHeader00">
                Explicit Consent & Standalone Agreement
              </li>
              <ul className="purchaseBottomLeftContent purchaseBottomLeftContent00">
                <li>
                  Consent to receive text messages is provided via an explicit,
                  optional opt-in.
                </li>
                <li>
                  <b>Standalone Consent: </b>Opting into SMS is a separate
                  agreement and is <b>not</b> a condition of purchase, loan
                  approval, or a requirement for any other service or agreement
                  with The Mortgageist Inc. You may use our mortgage services
                  without consenting to SMS.
                </li>
              </ul>

              <li className="purchaseBottomLeftHeader purchaseBottomLeftHeader00">
                Message Frequency & Fees
              </li>
              <ul className="purchaseBottomLeftContent purchaseBottomLeftContent00">
                <li>
                  Message frequency varies based on your interaction with our
                  services (e.g., loan status updates, appointment reminders).
                </li>
                <li>Standard message and data rates may apply</li>
              </ul>

              <li className="purchaseBottomLeftHeader purchaseBottomLeftHeader00">
                Opt-Out & Support
              </li>
              <ul className="purchaseBottomLeftContent purchaseBottomLeftContent00">
                <li>
                  <b>To Stop: </b>Reply <b>STOP</b> at any time to unsubscribe.
                  You will receive a single confirmation text.
                </li>
                <li>
                  <b>For Help: </b>Reply <b>HELP</b> for assistance, or contact
                  our support team at [Your Email Address/Phone].
                </li>
              </ul>

              <li className="purchaseBottomLeftHeader purchaseBottomLeftHeader00">
                Privacy & Data Protection (Carrier Mandated)
              </li>
              <ul className="purchaseBottomLeftContent purchaseBottomLeftContent00">
                <li>
                  Your phone number will only be used for communications related
                  to your mortgage inquiries and updates.
                </li>
                <li>
                  <b> No-Sharing Policy:</b> Mobile information will not be
                  shared with third parties or affiliates for marketing or
                  promotional purposes. All the above categories exclude text
                  messaging originator opt-in data and consent; this information
                  will not be shared with any third parties.
                </li>
              </ul>

              <div className="purchaseBottomLeftButton">
                <a
                  href="https://themortgageist.my1003app.com/2692605/register/"
                  target="_blank"
                  rel="noreferrer"
                  className="purchaseBottomLeftButtonLink"
                >
                  Apply Now
                </a>
              </div>
            </ol>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default CommunicationPolicy;
